$(window).on('load resize orientationchange', function() {
        $('.swatch').each(function(){
            var $carousel = $(this);
            if ($(window).width() > 1020) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        dots: false,
                        infinite: false,
                        focusOnSelect: false,
                        slidesToScroll: 1,
                        easing:'linear',
                        slidesToShow: 5,
                        variableWidth: true,
                        draggable: true,
                        slide: '.swatch-element',
                        centerMode: false
                    });
                }
            }
        });
    });